import React, {forwardRef} from 'react';

export const LicensePlate = forwardRef(({licenseplate, onChangeLicensePlate, resultCheck, onCheckButtonClicked
    }, ref) => {
    //const inputEl = useRef(null);

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && licenseplate && resultCheck === null) {
            onCheckButtonClicked()
        }
    }

    // const onBlurLicensePlate = (e) => {
    //     if (licenseplate && resultCheck === null){
    //         onCheckButtonClicked()
    //     }
    // }
    return (
            <div className="license-plate">
                <div className="license-plate__label">
                    Voer kenteken in
                </div>

                <div className='input-wrap'>
                    <div className='country'>NL</div>
                    <input
                        type="text"
                        value={licenseplate}
                        onChange={onChangeLicensePlate}
                        maxLength={6}
                        onKeyDown={handleKeyDown}
                        autoFocus={true}
                        disabled={resultCheck ? true : false}
                        //onBlur={onBlurLicensePlate}
                        ref={ref}
                    />
                </div>
            </div>
    );
})
